import { render, staticRenderFns } from "./CustomTags.vue?vue&type=template&id=4d21bd0e&scoped=true"
import script from "./CustomTags.vue?vue&type=script&lang=js"
export * from "./CustomTags.vue?vue&type=script&lang=js"
import style0 from "./CustomTags.vue?vue&type=style&index=0&id=4d21bd0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d21bd0e",
  null
  
)

export default component.exports